module.exports = __webpack_public_path__ + "media/images/worldpay-360ce74b.jpg";